import React from "react";
import NoDataFound from "../Common/NoDataFound";
import { Alert } from "bootstrap";
import {
  convertFirstLetterOfFullNameToCapital,
  convertFirstLetterToCapital,
  customName,
  getColorFromId,
} from "../../helpers/commonHelpers";
import { useSelector } from "react-redux";
import Loader from "../Common/Loader";
import {
  Button,
  Popover,
  OverlayTrigger,
  Accordion,
  Tooltip,
} from "react-bootstrap";

const AttendeesDetails = React.memo((props) => {
  const meetingData = useSelector((state) => state.meeting);

  const { attendees } = props.attendeesData;

  const tooltip = (attendee) => {
    return (
      <Tooltip id="tooltip">
        {attendee.name} / {attendee?.email}
      </Tooltip>
    );
  };
  const popoverHoverFocus = (title) => {
    return (
      <Popover id="popover-basic" className="custom-popover">
        <Popover.Body className="popover-body">{title}</Popover.Body>
      </Popover>
    );
  };

  return (
    <div className="form-group agenda">
      <label className="mt-2 mb-3 add-agenda">
        <h4>Attendee(s)</h4>
      </label>
      <div className="mt-2 agenda-box-border attendees-popup-list">
        {attendees.length > 0 ? (
          <form className=" details-form details-form-right responsive-table tbl-2-responsive">
            <table className="table table-striped">
              <thead>
                <tr className="text-align-center">
                  <th scope="col">Sl. No.</th>
                  <th scope="col">Attendee(s)</th>
                  <th scope="col">RSVP</th>
                </tr>
              </thead>

              <tbody>
                {attendees.length !== 0 ? (
                  <>
                    {attendees.map((attendee, index) => {
                      return (
                        <tr key={index}>
                          <td
                            data-label="Sl. No."
                            className="blue-bold-text"
                            scope="row"                            
                          >
                            {index + 1}
                          </td>
                          <td data-label="Attendees">
                            <div className="attendees responsive-right">
                              <div
                                className="attendee-list"
                                style={{
                                  backgroundColor: attendee?.profilePicture ? undefined : getColorFromId(attendee?._id),
                                  borderRadius: "50px",                                  
                                  color: "#fff",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  minWidth: "32px",
                                  height: "32px",
                                  // fontSize: "14px",
                                }}
                              >
                                {attendee?.profilePicture ? (
                                  <img
                                    src={`${process.env.REACT_APP_API_URL}${attendee.profilePicture}`}
                                    alt=""
                                    className="attendee-profile-picture icon-image"
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "50%",
                                      objectFit: "cover",
                                    }}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.style.display = "none";
  
                                      e.target.parentElement.style.backgroundColor = getColorFromId(
                                        attendee._id
                                      );
                                      e.target.parentElement.innerText = customName(
                                        attendee.name
                                      );
                                    }}
                                  />
                                ) : (
                                  customName(attendee.name)
                                )}
                              </div>

                              <div className="action-cmnt-text">
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  placement="top"
                                  overlay={popoverHoverFocus(attendee.name)}
                                >
                                  <p className="detail-name word-break">
                                    {convertFirstLetterOfFullNameToCapital(
                                      attendee.name
                                    )}
                                  </p>
                                </OverlayTrigger>

                                <p className="name-undertext detail-date-time  comment-text word-break">
                                  {attendee.email}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td data-label="RSVP" className="text-align-center">
                             



                            
                            {/* {convertFirstLetterToCapital(attendee.rsvp)} */}

                            {attendee.rsvp === "YES" ? (
                              <button disabled className="respond-action">
                                {" "}
                                <>&#x2713; </>Yes
                              </button>
                            ) : attendee.rsvp === "NO" ? (
                              <button disabled className="respond-action">
                                {" "}
                                <>&#x2713; </>No
                              </button>
                            ) : attendee.rsvp === "MAYBE" ? (
                              <button disabled className="respond-action">
                                {" "}
                                <>&#x2713; </>May Be
                              </button>
                            ) : (
                              <button disabled className="respond-action-meeting-details-rsvp">
                                {convertFirstLetterToCapital(attendee.rsvp)}
                              </button>
                            )}
                              
                          </td>
                        </tr>
                      );
                    })}
                  </> 
                ) : null}
              </tbody>
            </table>
          </form>
        ) : attendees.length === 0 && !meetingData.loading ? (
          <div className="no-data-img mt-3">
            <Alert
              status={"info"}
              message={"No data available."}
              timeoutSeconds={0}
            />
            <NoDataFound dataType={"meetingActivities"} />
          </div>
        ) : (
          <div
            className="meeting-page "
            style={{ textAlign: "center", paddingTop: 20 }}
          >
            <Loader />
          </div>
        )}
      </div>
    </div>
  );
});

export default AttendeesDetails;
